
<div class="d-inline-block">
  <feature id="debug_sort_order">
    [{{sortable.sort_order}}]
  </feature>
</div>
